import { derived, writable } from "svelte/store";

const getHostInfo = (isGameHost, gameHostId, usersStore, user) => {
	const allRoomHosts = writable(null);

	const allUserIds = derived(usersStore, $usersStore => {
		return Object.keys($usersStore);
	});

	const amIHost = derived([isGameHost, allRoomHosts], ([$isGameHost, $allRoomHosts]) => {
		if (Array.isArray($allRoomHosts)) {
			// if $allRoomHosts is an array that means we got info from iframe listener
			if ($allRoomHosts.length === 0) {
				return true;
			}
			if ($allRoomHosts.length !== 0) {
				return $allRoomHosts.includes(user.id);
			}
		}
		return $isGameHost;
	});

	const allHostIds = derived([allRoomHosts, gameHostId, allUserIds], ([$allRoomHosts, $gameHostId, $allUserIds]) => {
		if (Array.isArray($allRoomHosts)) {
			// if $allRoomHosts is an array that means we got info from iframe listener
			if ($allRoomHosts.length === 0) {
				console.log("setting allHostIds to allUsersIds");
				return $allUserIds;
			}
			if ($allRoomHosts.length !== 0) {
				return $allRoomHosts;
			}
		}
		return [$gameHostId];
	});

	window?.DIVE_APP?.listenOnHostChange?.(({ userIds }) => {
		console.log(userIds);
		if (userIds === "") {
			console.log("usersIds is an empty string");
			allRoomHosts.set([]);
			return;
		}

		console.log(`setting allRoomHosts as ${userIds.split(",").filter(Boolean)}`);
		allRoomHosts.set(userIds.split(",").filter(Boolean));
	});

	return { allHostIds, amIHost };
}

export default getHostInfo;
